/**
 * Enterprise catalogue API (tutor professional situation).
 * Paths stay `/employers` — that is the backend contract.
 */

import { apiClient } from './api-client';
import type { Enterprise } from '@/types/enterprise.types';

/** `GET /employers/search` — typeahead. */
export const searchEnterprises = async (q: string, limit: number = 20): Promise<Enterprise[]> => {
  const { data } = await apiClient.get<Enterprise[]>('/employers/search', {
    params: { q, limit },
  });
  return data;
};

/** `POST /employers` — create a manual enterprise. */
export const createEnterprise = async (name: string): Promise<Enterprise> => {
  const { data } = await apiClient.post<Enterprise>('/employers', { name });
  return data;
};
